// Sentry removed: keep a small no-op client instrumentation file for Next compatibility.

export const onRouterTransitionStart: ((...args: unknown[]) => void) | null =
  null;
